/** Preset column widths keyword that corresponds to pixels. */
export const columnsWidthPresets = {
  xsmall: 50,
  small: 100,
  medium: 200,
  large: 300,
  xlarge: 500
} as const;

/** Either a preset column width or a numeric value in pixels. */
export type ColumnWidth = keyof typeof columnsWidthPresets | number;
